import api from './api'

const VENDORS_URL = '/organisations'

export default {
  loadAccounts: function (vendorId) {
    var url = `${VENDORS_URL}/${vendorId}/accounts`
    return api.newRequest('get', url)
  },
  createAccount: function (vendorId, payload) {
    var url = `${VENDORS_URL}/${vendorId}/accounts`
    return api.newRequest('post', url, payload)
  },
  updateAccount: function (vendorId, accountId, payload) {
    var url = `${VENDORS_URL}/${vendorId}/accounts/${accountId}`
    return api.newRequest('patch', url, payload)
  },
  deleteAccount: function (vendorId, accountId) {
    var url = `${VENDORS_URL}/${vendorId}/accounts/${accountId}`
    return api.newRequest('delete', url)
  }
}
